import { render, staticRenderFns } from "./card-application-change-status-form.vue?vue&type=template&id=3b8bd5dc"
import script from "./card-application-change-status-form.vue?vue&type=script&lang=js"
export * from "./card-application-change-status-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports